const type = 'SET_CUSTOMER_PARAMS';

const setCustomerParams = (payload) => ({
  type,
  payload,
});

export { type };
export default setCustomerParams;
